import React from 'react';
import { merge } from './helpers.js';

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_InputWrapper__1Q3Dn{width:100%;position:relative}.styles-module_Input__1wA24{padding:8px 25px;border:1px solid var(--charcoal-gray-light);border-radius:var(--border-radius-medium);font-size:12px;transition:background-color 5000s ease-in-out 0s,border-color .2s ease-in;background:transparent!important;width:100%;color:var(--white);font-family:inherit}.styles-module_Input__1wA24:hover{border-color:rgba(var(--white-rgb),.3)}.styles-module_Input__1wA24:focus{outline:none;border-color:var(--color-primary)}.styles-module_Input__1wA24:-webkit-autofill{-webkit-text-fill-color:var(--brown-gray)!important;background:transparent;caret-color:var(--brown-gray)}.styles-module_Input__1wA24:disabled{opacity:.5;cursor:not-allowed}.styles-module_Input__1wA24:disabled:hover{border:1px solid var(--charcoal-gray-light)}.styles-module_Icon__tdN79{position:absolute;transform:scale(.7)}.styles-module_Icon__tdN79 svg{transition:all .2s ease-in-out;fill:var(--brown-gray)}.styles-module_IconRight__2-t21{right:2px;cursor:pointer}.styles-module_IconRight__2-t21 svg:active{opacity:.25}.styles-module_IconRight__2-t21 svg:hover{fill:var(--white)}.styles-module_IconLarge__2looH.styles-module_IconRight__2-t21{right:15px}.styles-module_IconLeft__AhEsW{left:5px}.styles-module_IconLarge__2looH{top:5px}.styles-module_InputSmall__x8qfP{padding:4px 14px;border-radius:var(--border-radius-large);font-size:11px}.styles-module_HasError__25GlR,.styles-module_HasError__25GlR:focus,.styles-module_HasError__25GlR:hover{border-color:var(--color-error)}";
var styles = {"InputWrapper":"styles-module_InputWrapper__1Q3Dn","Input":"styles-module_Input__1wA24","Icon":"styles-module_Icon__tdN79","IconRight":"styles-module_IconRight__2-t21","IconLarge":"styles-module_IconLarge__2looH","IconLeft":"styles-module_IconLeft__AhEsW","InputSmall":"styles-module_InputSmall__x8qfP","HasError":"styles-module_HasError__25GlR"};
styleInject(css_248z,{"insertAt":"top"});

var Input = function (_a) {
    var autoComplete = _a.autoComplete, autoFocus = _a.autoFocus, className = _a.className, dataCy = _a.dataCy, disabled = _a.disabled, hasError = _a.hasError, id = _a.id, leftIcon = _a.leftIcon, _b = _a.leftIconProps, leftIconProps = _b === void 0 ? {} : _b, maxLength = _a.maxLength, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, placeholder = _a.placeholder, pureOnChange = _a.pureOnChange, rightIcon = _a.rightIcon, _c = _a.rightIconProps, rightIconProps = _c === void 0 ? {} : _c, setRef = _a.setRef, small = _a.small, _d = _a.type, type = _d === void 0 ? 'text' : _d, value = _a.value;
    return (React.createElement("div", { className: styles.InputWrapper },
        leftIcon && (React.createElement("div", __assign({}, leftIconProps, { className: merge(styles.Icon, styles.IconLeft, small ? styles.IconSmall : styles.IconLarge, leftIconProps.className) }), leftIcon)),
        rightIcon && (React.createElement("div", __assign({}, rightIconProps, { className: merge(styles.Icon, styles.IconRight, small ? styles.IconSmall : styles.IconLarge, rightIconProps.className) }), rightIcon)),
        React.createElement("input", { id: id, type: type, className: merge(styles.Input, small && styles.InputSmall, hasError && styles.HasError, className), disabled: disabled, autoComplete: autoComplete, style: {
                paddingRight: rightIcon && (small ? 35 : 50),
                paddingLeft: leftIcon && 35,
            }, value: value || '', onBlur: function (event) { return onBlur && onBlur(event); }, placeholder: placeholder, onChange: !!pureOnChange
                ? pureOnChange
                : function (_a) {
                    var _value = _a.target.value;
                    return onChange(_value);
                }, ref: setRef, maxLength: maxLength, "data-cy": dataCy, autoFocus: autoFocus, onFocus: function (event) { return onFocus && onFocus(event); } })));
};
Input.defaultProps = {
    className: '',
    hasError: false,
    leftIcon: null,
    leftIconProps: {},
    placeholder: '',
    rightIcon: null,
    rightIconProps: {},
    small: false,
    setRef: function () { },
    disabled: false,
};
var inputStyles = {
    input: styles.Input,
    inputSmall: styles.InputSmall,
    inputWithError: styles.HasError,
    wrapper: styles.InputWrapper,
};

export { Input, inputStyles };
